import "./component-products.scss";
import { html, nothing } from "lit";
import ComponentBase from "./component-base";
import "./component-product";
import "./component-product-placeholder";
import { Products } from "../assets/js/libs/api";
import "./component-categories";
import { property, state } from "lit/decorators.js";

type Layout = "grid" | "list";

class ComponentProducts extends ComponentBase {
  static get tagName() {
    return "component-products";
  }

  @state()
  layout: Layout = "grid";

  @state()
  isLoading: boolean;

  @state()
  activeCategories: string[];

  @state()
  products: any[];

  @property()
  settings: any = nothing;

  constructor() {
    super();
    this.isLoading = true;
    this.activeCategories = [];
  }

  async GetData() {
    const res = (await Products.GetList()).data;
    return res;
  }

  async connectedCallback() {
    super.connectedCallback();
    this.products = await this.GetData();
    this.isLoading = false;
    this.requestUpdate();
  }

  _OnCategoryChange(e) {
    const { activeCategories } = e.detail;
    this.activeCategories = activeCategories;
    this.requestUpdate();
  }

  render() {
    const classList = "row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-6 align-content-start";
    if (this.isLoading)
      return html`
        <div
          class="${classList}"
        >
          ${new Array(9).fill({}).map(
        () => html`
              <div class="col mb-4 align-items-stretch">
                <component-product-placeholder></component-product-placeholder>
              </div>
            `
      )}
        </div>
      `;
    return html`
      <div class="d-flex justify-content-between mb-2">
        <component-categories
          @categoryChange=${(e) => this._OnCategoryChange(e)}
        ></component-categories>
        <div>
          <button 
            class="btn btn-light" 
            @click=${() => { this.layout = this.layout === 'grid' ? 'list' : 'grid' }}>
            <i class="bi bi-${this.layout === 'grid' ? 'list' : 'grid'}"></i>
          </button>
          ${this.settings}
        </div>
      </div>
      <div
        id="products"
        class="${classList}"
      >
        ${this.products
        .filter(
          (product) =>
            this.activeCategories.length == 0 ||
            this.activeCategories.includes(product.type)
        )
        .map((product) => this.RenderProduct(product))}
      </div>
    `;
  }

  RenderProduct(product) {
    let className = "col align-items-stretch";
    if (this.layout === "list") {
      className += " w-100 mb-3";
    } else {
      className += " mb-4";
    }

    return html`
      <div class="${className}">
        <component-product
          @addProduct=${(e) => {
        this.dispatchEvent(
          new CustomEvent("addToCart", {
            detail: {
              product: {
                ...product,
                quantity: e.detail.quantity,
                customizations: e.detail.customizations,
              },
            },
          })
        );
      }}
          .product=${product}
          .mode=${this.layout}
        ></component-product>
      </div>
    `;
  }
}
ComponentProducts.Register();
export default ComponentProducts;
